import {
  ArrowDropDown,
  Cable,
  Close,
  FilterAltOutlined,
  ImportExportOutlined,
  Public,
  Sell,
} from "@mui/icons-material";
import {
  alpha,
  Badge,
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid2,
  IconButton,
  Menu,
  MenuItem,
  Modal,
  Paper,
  Popover,
  Typography,
  useTheme,
  TextField,
  InputAdornment,
  Tooltip,
  Stack,
  InputLabel,
  Select,
  FormControl,
  Divider,
  Drawer,
  useMediaQuery,
  CircularProgress,
} from "@mui/material";

import dayjs from "dayjs";
import { useState, forwardRef, useImperativeHandle, useEffect } from "react";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import useStyles from "./styles";
import {
  ModalVerify,
  ModalDate,
  ModalTextField,
  ModalAutoComplete,
} from "./modais";
import ModalDateTime from "../../../componentes/easyLogs/pickerDateTimeCustom";
const optionsTimesRange = [
  { value: 5, unit: "minutos", unitEn: "minutes" },
  { value: 15, unit: "minutos", unitEn: "minutes" },
  { value: 30, unit: "minutos", unitEn: "minutes" },
  { value: 1, unit: "hora", unitEn: "hour" },
  { value: 3, unit: "horas", unitEn: "hours" },
  { value: 6, unit: "horas", unitEn: "hours" },
  { value: 12, unit: "horas", unitEn: "hours" },
  { value: 24, unit: "horas", unitEn: "hours" },
  { value: 2, unit: "dias", unitEn: "days" },
  { value: 7, unit: "dias", unitEn: "days" },
  { value: 1, unit: "mês", unitEn: "month" },
  { value: 3, unit: "meses", unitEn: "months" },
  { value: 6, unit: "meses", unitEn: "months" },
  { value: 1, unit: "ano", unitEn: "year" },
];
const Filters = forwardRef((props, ref) => {
  const {
    getAlocationsClienteHandle = () => {},
    getLogsClienteHandle = () => {},
    getCountPortsHandle = () => {},
    getDataFilter = () => {},
    data = null,
    timeZone = "America/Sao_Paulo",
    updateController = () => {},
    loading,
  } = props;

  const [anchorElDate, setAnchorElDate] = useState(null);
  const [anchorElPort, setAnchorElPort] = useState(null);
  const [anchorElIP, setAnchorElIP] = useState(null);
  const [ips, setIps] = useState([]);
  const [filterIP, setFilterIP] = useState("");
  const [ports, setPorts] = useState([]);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [filterPort, setFilterPort] = useState("");
  const [filterDateInicial, setFilterDateInicial] = useState(
    dayjs(new Date())?.subtract(1, "hour").second(0)
  );
  const [filterDateFinal, setFilterDateFinal] = useState(
    dayjs(new Date())?.second(59)
  );

  const [change, setChange] = useState(false);
  const theme = useTheme();
  const styles = useStyles(theme);

  const upMD = useMediaQuery(theme.breakpoints.up("md"));

  useImperativeHandle(ref, () => ({
    getTimeFilter() {
      return { filterDateInicial, filterDateFinal };
    },
  }));

  useEffect(() => {
    if (!timeZone) return;
    setFilterDateInicial((data) => data.tz(timeZone));
    setFilterDateFinal((data) => data.tz(timeZone));
  }, [timeZone]);

  useEffect(() => {
    if (!data) return;
    setIps(data?.ips?.map((a) => a.ip) || []);
    setPorts(expandPorts(data?.ports?.map((a) => a.port)) || []);
    // função que adicione um range de 512 portas para cada portas do array
  }, [data]);

  const expandPorts = (ports) => {
    const expandedSet = new Set();

    ports.forEach((port) => {
      for (let i = 0; i < 512; i++) {
        expandedSet.add(port + i);
      }
    });

    return Array.from(expandedSet).sort((a, b) => a - b);
  };

  const handleClick = (event, filterType) => {
    if (filterType === "date") {
      setAnchorElDate(event.currentTarget);
    } else if (filterType === "ip") {
      setAnchorElIP(event.currentTarget);
    } else {
      setAnchorElPort(event.currentTarget);
    }
  };

  const handleFilter = () => {
    let filters = {
      time: { timeInit: filterDateInicial, timeEnd: filterDateFinal },
      port: filterPort,
      ip: filterIP,
    };
    getLogsClienteHandle(filters);
    getAlocationsClienteHandle(filters);
    getCountPortsHandle(filters);
    getDataFilter(filters);
  };

  const handleCleanFilters = () => {
    setFilterDateInicial(
      dayjs(new Date())?.tz(timeZone).subtract(1, "hour").second(59)
    );
    setFilterDateFinal(dayjs(new Date())?.tz(timeZone).second(0));
    setFilterPort("");
    setChange(false);
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          width: "100%",
          justifyContent: "space-between",
        }}
      >
        <Box sx={styles.backgroundBox}>
          <Grid2
            container
            rowSpacing={1}
            spacing={1}
            sx={styles.gridItemDesktop}
          >
            <Grid2 item size={styles.sizeGridItem}>
              <Paper
                sx={{
                  ...styles.paperBrick,
                  ...(loading && styles.disable),
                }}
                onClick={(e) => handleClick(e, "date")}
              >
                <CalendarMonthIcon
                  sx={{ ...styles.size, ...styles.iconsFilter }}
                />
                <Typography sx={styles.text}>{`Periodo: ${dayjs(
                  filterDateInicial
                ).format("DD/MM/YYYY HH:mm")} até ${dayjs(
                  filterDateFinal
                ).format("DD/MM/YYYY HH:mm")}`}</Typography>
                <ArrowDropDown sx={styles.size} />
              </Paper>
            </Grid2>
            <Grid2 item size={styles.sizeGridItem}>
              <Paper
                sx={{
                  ...styles.paperBrick,
                  ...(loading && styles.disable),
                }}
                onClick={(e) => handleClick(e, "ip")}
              >
                <Public sx={{ ...styles.size, ...styles.iconsFilter }} />
                <Typography sx={styles.text}>{`IP Público${
                  !!filterIP ? ": " + filterIP : ""
                }`}</Typography>
                <ArrowDropDown sx={styles.size} />
              </Paper>
            </Grid2>

            <Grid2 item size={styles.sizeGridItem}>
              <Paper
                sx={{
                  ...styles.paperBrick,
                  ...(loading && styles.disable),
                }}
                onClick={(e) => handleClick(e, "port")}
              >
                <Cable sx={{ ...styles.size, ...styles.iconsFilter }} />
                <Typography sx={styles.text}>{`Porta${
                  !!filterPort ? ": " + filterPort : ""
                }`}</Typography>
                <ArrowDropDown sx={styles.size} />
              </Paper>
            </Grid2>

            <Grid2 item size={styles.sizeGridItem}>
              <Box sx={{ ...styles.boxTitle, display: "flex", gap: 1 }}>
                <Tooltip title={!loading ? "Filtrar" : "Interromper"}>
                  <span>
                    {!loading ? (
                      <Button
                        //disabled={!change}
                        sx={styles.buttonSearch}
                        startIcon={<FilterAltOutlined />}
                        onClick={() => handleFilter()}
                      >
                        Filtrar
                      </Button>
                    ) : (
                      <Button
                        //disabled={!change}
                        sx={styles.buttonSearch}
                        startIcon={
                          <CircularProgress
                            sx={{ ml: 0.5 }}
                            size={18}
                            color="inherit"
                          />
                        }
                        onClick={() => updateController()}
                      >
                        Interromper...
                      </Button>
                    )}
                  </span>
                </Tooltip>

                <Divider orientation="vertical" flexItem />
                <Tooltip
                  title={
                    change ? "Limpar Filtros" : "Nenhum filtro selecionado"
                  }
                >
                  <span>
                    <Button
                      disabled={loading}
                      sx={styles.buttonClearFilters}
                      startIcon={<Close />}
                      onClick={handleCleanFilters}
                    >
                      Limpar Filtros
                    </Button>
                  </span>
                </Tooltip>
              </Box>
            </Grid2>
          </Grid2>
        </Box>
        <Stack
          sx={styles.containerButtonFilter}
          alignItems={"end"}
          width={"100%"}
        >
          <Button
            width={"fit-content"}
            variant="contained"
            sx={{
              backgroundColor: theme.palette.easyLog.primary,
              borderRadius: "5px",
              p: "5px 15px",
            }}
            startIcon={<FilterAltOutlined />}
            onClick={() => setOpenDrawer(true)}
          >
            Filtros
          </Button>
          <Drawer
            anchor={"right"}
            open={openDrawer && !upMD}
            sx={styles.paperDrawer}
            onClose={() => setOpenDrawer(false)}
          >
            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}
            >
              <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                <FilterAltOutlined />
                <Typography>Filtros</Typography>
              </Box>

              <IconButton onClick={() => setOpenDrawer(false)}>
                <Close />
              </IconButton>
            </Stack>

            <Paper
              sx={styles.paperBrick}
              onClick={(e) => handleClick(e, "date")}
            >
              <CalendarMonthIcon
                sx={{ ...styles.size, ...styles.iconsFilter }}
              />
              <Typography sx={styles.text}>{`Periodo: ${dayjs(
                filterDateInicial
              ).format("DD/MM/YYYY HH:mm")} até ${dayjs(filterDateFinal).format(
                "DD/MM/YYYY HH:mm"
              )}`}</Typography>
              <ArrowDropDown sx={styles.size} />
            </Paper>

            <Paper sx={styles.paperBrick} onClick={(e) => handleClick(e, "ip")}>
              <Public sx={{ ...styles.size, ...styles.iconsFilter }} />
              <Typography sx={styles.text}>{`IP Público${
                !!filterIP ? ": " + filterIP : ""
              }`}</Typography>
              <ArrowDropDown sx={styles.size} />
            </Paper>

            <Paper
              sx={styles.paperBrick}
              onClick={(e) => handleClick(e, "port")}
            >
              <Cable sx={{ ...styles.size, ...styles.iconsFilter }} />
              <Typography sx={styles.text}>{`Porta${
                !!filterPort ? ": " + filterPort : ""
              }`}</Typography>
              <ArrowDropDown sx={styles.size} />
            </Paper>
            <Stack
              direction={"row"}
              gap={1}
              justifyContent={"center"}
              sx={{ position: "absolute", bottom: 20, left: 10, right: 10 }}
            >
              <Button
                disabled={loading}
                sx={styles.buttonClearFilters}
                startIcon={<Close />}
                onClick={handleCleanFilters}
              >
                Limpar Filtros
              </Button>
              {!loading ? (
                <Button
                  //disabled={!change}
                  sx={styles.buttonSearch}
                  startIcon={<FilterAltOutlined />}
                  onClick={() => {
                    handleFilter();
                    setOpenDrawer(false);
                  }}
                >
                  Filtrar
                </Button>
              ) : (
                <Button
                  //disabled={!change}
                  sx={styles.buttonSearch}
                  startIcon={
                    <CircularProgress
                      sx={{ ml: 0.5 }}
                      size={18}
                      color="inherit"
                    />
                  }
                  onClick={() => {
                    updateController();
                  }}
                >
                  Interromper...
                </Button>
              )}
            </Stack>
          </Drawer>
        </Stack>
      </Box>
      <ModalTextField
        title="Porta"
        type="number"
        setChange={setChange}
        anchorEl={anchorElPort}
        setAnchorEl={setAnchorElPort}
        selected={filterPort}
        setSelected={setFilterPort}
      />
      <ModalAutoComplete
        options={ips}
        title="IP"
        type="text"
        setChange={setChange}
        anchorEl={anchorElIP}
        setAnchorEl={setAnchorElIP}
        selected={filterIP}
        setSelected={setFilterIP}
      />

      <ModalDateTime
        optionsTimesRange={optionsTimesRange}
        setChange={setChange}
        key={"modalDate"}
        anchorEl={anchorElDate}
        setAnchorEl={setAnchorElDate}
        dateInitial={filterDateInicial}
        dateFinal={filterDateFinal}
        setDateFinal={setFilterDateFinal}
        setDateInitial={setFilterDateInicial}
      />
    </>
  );
});
export default Filters;
